import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { LoginGuard } from '../calvin-emr-shared/guards/login.guard';
import { ForgotPasswordPageComponent } from './forgot-password-page/forgot-password-page.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { PATH_LOGIN, PATH_FORGOT_PASSWORD } from './login.global';
import { PATH_PATIENTS } from 'src/app/patients/patients.global';
import { isKnightmedsCabinetMode } from '../../environments/deploy_info';
import { PATH_RELEASE_PAGES } from '../global';

const getPostLoginPath = (): string =>
  isKnightmedsCabinetMode() ? PATH_RELEASE_PAGES : PATH_PATIENTS;

export const loginRoutes: Routes = [
  {
    path: PATH_LOGIN,
    component: LoginPageComponent,
    canActivate: [() => inject(LoginGuard).canActivate(getPostLoginPath())],
  },
  { path: PATH_FORGOT_PASSWORD, component: ForgotPasswordPageComponent },
];
